import React from "react"
import { Navigate } from "react-router-dom"
import { connect } from "react-redux"

const mapStateToProps = (storeState, ownProps) => {
  const { sessionId } = storeState.session
  return {
    ...ownProps,
    loggedIn: sessionId != null
  }
};

const ProtectedRoute = ({ loggedIn, children }) => {
  if (!loggedIn) {
    return <Navigate to="/login" />;
  }
  return children;
};

export default connect(mapStateToProps)(ProtectedRoute);